import { useLocation, useNavigate } from 'react-router-dom';
import { useState, useCallback, useEffect, FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState, AppDispatch } from '@reducers/index';
import { getAllMyAppsListInfo } from '@reducers/service/serviceThunk';
import { IResponseRegisteredAppInfo } from '@models/manager/service/serviceModel';
import { axiosDummyInstance, axiosInstance } from '@utils/axios/axiosInstance';

import SuggestAppList from './suggestAppList';
import SearchAppList from './searchAppList';
import SelectedAppList from './selectedAppList';

const AddCompetitorsApp = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();

  // myApp
  const [myAppObj, setMyAppObj] = useState<IResponseRegisteredAppInfo | null>(null);
  // competitorAppList
  const [selectedAppList, setSelectedAppList] = useState<IResponseRegisteredAppInfo[]>([]);

  // useEffect for return prevstep
  useEffect(() => {
    // 이전단계에서 selectedAppObj 를 state 로 넘겨받지 못할 경우 myApp 등록단계로 넘김처리
    if (!!location && !!location?.state && location?.state.hasOwnProperty('selectedAppObj')) {
      //@ts-ignore
      setMyAppObj(location?.state?.selectedAppObj ?? null);
    } else {
      navigate('/appManager/myApps');
    }
  }, [location]);

  // SelectedCompetitorAppList
  const onClickSelectApp = useCallback(
    (item: IResponseRegisteredAppInfo) => {
      const currentIndex = selectedAppList.findIndex((stateItem) => stateItem.appId === item.appId);
      if (currentIndex > -1) {
        setSelectedAppList((prev) => [...prev.filter((prevItem) => prevItem.appId !== item.appId)]);
      } else {
        setSelectedAppList((prev) => prev.concat(item));
      }
    },
    [selectedAppList]
  );

  // onClickNextHandler
  const onClickNextButton = useCallback(async () => {
    // {myApp: myAppObj, competitorsApp: selectedAppList} 으로 요청
    // // 아래는 실제 연결코드
    // const { data, status } = await axiosInstance.post('/app/my', {
    //   appInfo: {
    //     appId: myAppObj?.appId,
    //     providerType: myAppObj?.provider_type,
    //   },
    //   competitorAppsInfo: selectedAppList.map((item) => ({
    //     appId: item?.appId,
    //     providerType: item?.provider_type,
    //   })),
    // });

    const { data, status } = await axiosDummyInstance.get('/api/commonGetResponse.json'); //TODO: 추후 연결시 삭제할것..
    if (status === 200) {
      // 요청 성공 시 전체 리스트 가져오기 + MyApps 화면으로 이동처리
      dispatch(getAllMyAppsListInfo({ userId: 'sss' }));
      navigate('/appManager/myApps');
    } else {
      navigate('/appManager/myApps');
    }

    // // 아래는 기존 코드
    // const { data, status } = await axiosDummyInstance.get('/api/commonGetResponse.json');
    // if (status === 200) {
    //   // 요청 성공 시 전체 리스트 가져오기 + MyApps 화면으로 이동처리
    //   dispatch(getAllMyAppsListInfo({ userId: 'sss' }));
    //   navigate('/appManager/myApps');
    // }
  }, [navigate, myAppObj, selectedAppList]);

  return (
    <>
      <div className="manager">
        <h2 className="manager-tit">Add Competitor Apps</h2>
        <p className="manager-dsc">Please provide a description for adding a competitor app.</p>
      </div>
      <SelectedAppList myAppObj={myAppObj} selectedAppList={selectedAppList} onClickSelectApp={onClickSelectApp} />
      <div className="umanager">
        {!!myAppObj && (
          <>
            <SuggestAppList
              selectedMyApp={myAppObj}
              selectedCompetitorAppList={selectedAppList}
              onClickSelectApp={onClickSelectApp}
            />
            <SearchAppList
              selectedMyApp={myAppObj}
              selectedCompetitorAppList={selectedAppList}
              onClickSelectApp={onClickSelectApp}
            />
          </>
        )}
      </div>
      <div className="bottom-btn">
        <button
          type="button"
          className="btn pri"
          // disabled={selectedAppList?.length === 0 ? true : false}
          onClick={onClickNextButton}
        >
          NEXT
        </button>
      </div>
    </>
  );
};

export default AddCompetitorsApp;
